import React from "react";
import { useTable } from "react-table";
import "./table.scss"
import Pagination from "./pagination/index";


const Index = ({ 
  columns, 
  data, 
  dark, 
  hover, 
  small, 
  pagination,
  loading = false,
  error,
  onRetry,
  skeletonRows = 10,
  emptyMessage = "Data tidak ditemukan",
  emptyContent = null
}) => {
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: data || [],
  });

  const hasData = rows.length > 0;
  const isInitialLoading = loading && !hasData;
  const isRefreshing = loading && hasData;
  const columnCount = headerGroups?.[0]?.headers?.length || columns.length || 1;

  return (
    <div className="table-wrapper" aria-busy={loading}>
      {isRefreshing && (
        <div className="table-loading-indicator" role="status" aria-live="polite">
          <span className="spinner-border spinner-border-sm" aria-hidden="true" />
          <span>Memuat data...</span>
        </div>
      )}
      {error && hasData && !loading && (
        <div className="table-error-banner" role="alert">
          <span>{error}</span>
          {onRetry && (
            <button type="button" className="table-retry-button" onClick={onRetry}>
              Coba lagi
            </button>
          )}
        </div>
      )}
    <div className={`table-responsive table-content ${isRefreshing ? "is-refreshing" : ""}`}>
      <table
        {...getTableProps()}
        className={`table ${dark && "table-dark"} ${hover && "table-hover"
          } ${small && "table-sm"}`}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody aria-live="polite">
          {isInitialLoading && Array.from({ length: skeletonRows }).map((_, rowIndex) => (
            <tr key={`skeleton-row-${rowIndex}`} className="table-skeleton-row">
              {Array.from({ length: columnCount }).map((__, columnIndex) => (
                <td key={`skeleton-cell-${rowIndex}-${columnIndex}`}>
                  <div className="table-skeleton" />
                </td>
              ))}
            </tr>
          ))}
          {!isInitialLoading && rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} style={{ fontSize: 14 }}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {error && !hasData && !loading && (
            <tr>
              <td colSpan={columnCount} className="table-state-cell">
                <div className="table-error-state" role="alert">
                  <span className="material-icons-round" aria-hidden="true">error_outline</span>
                  <p>{error}</p>
                  {onRetry && (
                    <button type="button" className="table-retry-button" onClick={onRetry}>
                      Coba lagi
                    </button>
                  )}
                </div>
              </td>
            </tr>
          )}
          {!loading && !error && !hasData && (
              <tr>
                <td colSpan={columnCount} className="table-state-cell">
                  {emptyContent || emptyMessage}
                </td>
              </tr>
          )}
        </tbody>
      </table>

    </div>
    <div className={`table-pagination ${loading ? "is-disabled" : ""}`}>
    {pagination && hasData && !isInitialLoading && (
      <Pagination
        page={pagination?.page}
        dataTotal={data?.length}
        recordTotal={pagination?.totalData}
        maxPage={pagination?.maxPage}
        toggle={pagination?.toggle}
        length={pagination?.length}
        onPageSizeChange={pagination?.onPageSizeChange}
        disabled={loading}
      />
    )}
  </div>
  </div>
  );
};

export default Index;
